<template>
  <main id="main" class="main-site">
    <div class="container">
      <div class="wrap-breadcrumb">
        <ul>
          <li class="item-link">
            <router-link to="/loja" class="fa fa-home"></router-link>
          </li>
          <li class="item-link">
            <span> Meu <span v-if="formKombi.tipo == 'carrinho'">Carrinho</span><span v-else-if="formKombi.tipo == 'cotacao'">Cotação</span> </span>
          </li>
        </ul>
      </div>
      <div class="main-content-area">
        <div class="main-content-area">
          <div class="row">
            <div class="col-md-12">
              <h3>
                Meu <span v-if="formKombi.tipo == 'carrinho'">Carrinho</span><span v-else-if="formKombi.tipo == 'cotacao'">Cotação</span>:
                {{ formKombi.kombiCode }}
              </h3>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <h3 v-if="!isConsumoProprio" class="box-title">Faturamento para cliente final - venda direta</h3>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <vue-good-table :columns="columnsCli" :rows="formKombi.clienteInfo" :pagination-options="{ enabled: false }" styleClass="vgt-table">
                <template slot="table-row" slot-scope="props">
                  {{ props.formattedRow[props.column.field] }}
                </template>
                <div slot="emptystate">Sem dados para exibição</div>
              </vue-good-table>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <h3 class="box-title">Produtos</h3>
            </div>
          </div>
          <div class="row">
            <div class="col-md-2">
              <FormHelper
                :inputVar="formAddProdutos.codigo"
                :form="formAddProdutos"
                :mask="['#-#', '##-#', '###-#', '####-#', '#####-#', '######-#']"
                label="Código"
                placeholder="Ex: 1234-2"
              ></FormHelper>
            </div>
            <div class="col-md-1">
              <FormHelper :inputVar="formAddProdutos.quantidade" :form="formAddProdutos" label="Qtde" mask="####"></FormHelper>
            </div>
            <div class="col-md-1 col-only-button">
              <button aria-label="Adicionar Produto" class="btn primary-button" v-on:click.prevent="addProduto()">
                <i class="fa fa-plus-circle fa-lg" />
              </button>
            </div>
          </div>
          <Loader v-if="formKombi.loading || isCalculating" />
          <div id="in-stock-list">
            <div class="row">
              <div class="col-md-12">
                <div class="instock-info">{{ formKombi.inStockText }}</div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <table style="width: 100%">
                  <tr class="cart-table-header">
                    <th class="text-center"><i class="fa fa-times fa-lg" /></th>
                    <th class="text-center">Código</th>
                    <th class="text-center">Foto</th>
                    <th>Descrição</th>
                    <th class="text-center">Qtde</th>
                    <th class="text-center">Valor Un. Revenda</th>
                    <th v-if="!isConsumoProprio" class="text-center">Valor Unitário</th>
                    <th class="text-center">

                      <i class="fa fa-exclamation-circle fa-lg" />
                    </th>
                  </tr>
                  <tr class="cart-table-data" v-for="(product, index) in formKombi.inStockList" :key="'instock-' + index">
                    <td v-if="product.prodPai == '|0|'" class="text-center">
                      <a class="fa fa-times fa-lg" style="color: red" v-on:click.prevent="removeInStock(index)" href="#" />
                    </td>
                    <td v-else class="text-center">
                      <a class="fa fa-times fa-lg" style="color: gray" />
                    </td>
                    <td class="text-center">
                      <span v-if="product.prodPai != '|0|'"
                        ><strong>Associado<br /></strong></span
                      >{{ product.code }}-{{ product.dv }}
                    </td>
                    <td class="text-center">
                      <img class="cart-table-img" v-bind:src="product.img" />
                    </td>
                    <td>{{ product.desc }}</td>
                    <td v-if="product.prodPai == '|0|'" class="text-center">
                      <input
                        class="form-control cart-num-input"
                        v-model="product.qtde"
                        type="number"
                        min="1"
                        v-bind:disabled="isConsumoProprio || isCalculating"
                        v-on:change="updateQt(product)"
                      />
                    </td>
                    <td v-else class="text-center">
                      <input class="form-control cart-num-input" v-model="product.qtde" type="number" min="1" disabled="true" />
                    </td>
                    <td class="text-center">
                      {{ formatCurrency(product.unitV) }}
                    </td>
                    <td v-if="!isConsumoProprio" class="text-center">
                      <input
                        :readonly="
                          (formKombi.parcelas.value === 'Financ. BV Financeira - S/ Comissão com Frete Incluso' ||
                            parcelaLabel === 'Financ. BV Financeira - S/ Comissão com Frete Incluso') &&
                          formKombi.formaPag.value === 'prazo'
                            ? true
                            : false
                        "
                        class="form-control cart-price-input"
                        v-on:focusout="updateValorProduto(product)"
                        style="margin: auto"
                        :id="'cliente-in-' + index"
                        v-model="product.clienteV"
                        v-money="moneyConfig"
                        v-bind="moneyConfig"
                        v-bind:disabled="formKombi.formaPag.value == 'cartaocredito'"
                      />
                    </td>
                    <td class="text-center">
                      <i class="fa fa-exclamation-circle fa-lg cart-product-info" style="color: #0083ca">
                        <ProductTaxesTooltip :productTaxes="product.taxes" :origin="product.origin" />
                      </i>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>

          <div id="out-stock-list">
            <div class="row">
              <div class="col-md-12">
                <div class="outstock-info">{{ formKombi.outStockText }}</div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <table style="width: 100%">
                  <tr class="cart-table-header">
                    <th class="text-center"><i class="fa fa-times fa-lg" /></th>
                    <th class="text-center">Código</th>
                    <th class="text-center">Foto</th>
                    <th>Descrição</th>
                    <th class="text-center">Qtde</th>
                    <th class="text-center">Valor Un. Revenda</th>
                    <th v-if="!isConsumoProprio" class="text-center">Valor Unitário</th>
                    <th class="text-center">
                      <i class="fa fa-exclamation-circle fa-lg" />
                    </th>
                  </tr>
                  <tr class="cart-table-data" v-for="(product, index) in formKombi.outStockList" :key="'outstock-' + index">
                    <td v-if="product.prodPai == '|0|'" class="text-center">
                      <a class="fa fa-times fa-lg" style="color: red" v-on:click.prevent="removeOutStock(index)" href="#" />
                    </td>
                    <td v-else class="text-center">
                      <a class="fa fa-times fa-lg" style="color: gray" />
                    </td>
                    <td class="text-center">
                      <span v-if="product.prodPai != '|0|'"
                        ><strong>Associado<br /></strong></span
                      >{{ product.code }}-{{ product.dv }}
                    </td>
                    <td class="text-center">
                      <img class="cart-table-img" v-bind:src="product.img" />
                    </td>
                    <td>
                      <div style="display: flex; flex-direction: column; align-items: flex-start">
                        <span>{{ product.desc }}</span>
                      </div>
                    </td>
                    <td v-if="product.prodPai == '|0|'" class="text-center">
                      <input
                        class="form-control cart-num-input"
                        v-model="product.qtde"
                        type="number"
                        min="1"
                        v-bind:disabled="isConsumoProprio || isCalculating"
                        v-on:change="updateQt(product)"
                      />
                    </td>
                    <td v-else class="text-center">
                      <input class="form-control cart-num-input" v-model="product.qtde" type="number" min="1" disabled="true" />
                    </td>
                    <td class="text-center">
                      {{ formatCurrency(product.unitV) }}
                    </td>
                    <td v-if="!isConsumoProprio" class="text-center">
                      <input
                        :disabled="isConsumoProprio"
                        :readonly="
                          (formKombi.parcelas.value === 'Financ. BV Financeira - S/ Comissão com Frete Incluso' ||
                            parcelaLabel === 'Financ. BV Financeira - S/ Comissão com Frete Incluso') &&
                          formKombi.formaPag.value === 'prazo'
                        "
                        class="form-control cart-price-input"
                        v-on:focusout="updateValorProduto(product)"
                        :id="'cliente-out-' + index"
                        v-model="product.clienteV"
                        v-money="moneyConfig"
                        v-bind:disabled="formKombi.formaPag.value == 'cartaocredito'"
                      />
                    </td>
                    <td class="text-center">
                      <i class="fa fa-exclamation-circle fa-lg cart-product-info" style="color: #0083ca">
                        <ProductTaxesTooltip :productTaxes="product.taxes" :origin="product.origin" />
                      </i>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <h3 class="box-title">Vendedor</h3>
            </div>
          </div>

          <div class="row">
            <div class="col-md-4">
              <input class="form-control" v-model="formKombi.vendedor.value.label" :readonly="true" v-if="!reativacao" />

              <FormHelper
                :inputVar="formKombi.vendedor"
                :form="formKombi"
                :options="formKombi.vendedores"
                type="select"
                label="Selecione um vendedor"
                placeholder="Vendedor"
                :change="alterarVendedor"
                v-if="reativacao"
              ></FormHelper>
            </div>
          </div>

          <SelectShippingNew
            v-if="formKombi != null"
            :valorTotal="formKombi.baseCalculoFrete"
            v-on:updateCarrinho="this.updateAfterSelectFrete"
            v-on:showLoading="this.showLoading"
            :formulario="this.formulario"
          />

          <div class="row">
            <div class="col-md-12">
              <h3 class="box-title">Tipo de pagamento</h3>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12" id="formas-pagamento">
              <FormHelper
                :inputVar="formKombi.formaPag"
                :form="formKombi"
                :options="payForms().filter((pay) => pay.visible == true)"
                :disabled="isConsumoProprio"
                :change="formaPagOnChange"
                type="radio"
                label="Forma de pagamento"
              ></FormHelper>
            </div>
          </div>

          <div class="row" v-if="isPossivelConfirmacaoAut == true && formKombi.formaPag.value === 'vista'">
            <div class="col-md-12">
              <label style="font-weight: bold; font-size: 15px"> Precisa de alguma alteração em seu pedido? </label>
              <div class="row">
                <div class="col-md-4">
                  <div class="choose-radio-methods">
                    <label class="inline-radio">
                      <input name="radio-acompanhamento" value="1" type="radio" v-model="formKombi.vendaNaoRealizaAcompanhamento" />
                      <span> Não (Confirmação do pedido e emissão do boleto automaticamente) </span>
                    </label>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="choose-radio-methods">
                    <label class="inline-radio">
                      <input name="radio-tipo-pessoa" value="0" type="radio" checked v-model="formKombi.vendaNaoRealizaAcompanhamento" />
                      <span> Sim (Confirmação do pedido e emissão do boleto pelo vendedor) </span>
                    </label>
                  </div>
                </div>
              </div>
              <hr />
            </div>
          </div>
          <div id="pay-method">
            <div class="row">
              <div class="col-md-4">
                <FormHelper
                  :inputVar="formKombi.meioPag"
                  :form="formKombi"
                  :options="getMeiosPag()"
                  type="select"
                  :disabled="isConsumoProprio"
                  label="Meio de pagamento"
                  placeholder="Meio de pagamento"
                  :change="alterarMeioPagamento"
                ></FormHelper>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="alert alert-warning" role="alert">
                  <i class="fa fa-warning"></i>
                  Pagamentos em "Boleto", o tipo de transportadora poderá ser "O Mesmo" (Retira).
                </div>
              </div>
            </div>
          </div>
          <div id="parcels" class="row">
            <div class="col-md-5">
              <FormHelper
                :inputVar="formKombi.parcelas"
                :form="formKombi"
                :options="formKombi.optionsParcelas"
                type="select"
                label="Parcelas"
                placeholder="Parcelas"
              >
              </FormHelper>
            </div>
          </div>
          <div v-if="liberaPagamentoCartaoCredito && this.formKombi.pagCartaoCredito == true" id="cartaocredito" class="row">
            <div class="col-md-12">
              <div class="row">
                <div class="col-md-12">
                  <FormHelper
                    :inputVar="formKombi.bandeiraCartao"
                    :form="formKombi"
                    :options="getFlags().filter((pay) => pay.visible == true)"
                    :change="alterarBandeiraCartao"
                    type="radio"
                    label="Bandeira"
                  ></FormHelper>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <Loader v-if="loadingCardValues" />
              <FormHelper
                :inputVar="formKombi.cartaocredito"
                :form="formKombi"
                :options="formKombi.optionsCartaoCredito"
                type="select"
                label="Parcelas Cartão"
                placeholder="Parcelas Cartão"
                :change="alterarParcelaCartao"
                v-if="!loadingCardValues"
              ></FormHelper>
            </div>
          </div>
          <div
            v-if="formKombi.formaPag.value === 'prazo' && formKombi.parcelas.value !== null && showFinanciamentoSolar"
            id="divFinanciamentoSolar"
            class="panel panel-default"
          >
            <div class="panel-heading">
              <strong>FINANCIAMENTO DE ENERGIA SOLAR</strong>
              <br />
              Linha de financiamento destinada à aquisição de sistemas de distribuição de energia a partir de fontes renováveis
            </div>
            <div class="panel-body form row">
              <div class="col-md-12">
                <form class="form-horizontal" @submit.prevent="updateFinanciamentoSolar">
                  <div class="row">
                    <div class="col-md-4">
                      <form-helper
                        :inputVar="formFinanciamentoSolar.diasPagamento"
                        :form="formFinanciamentoSolar"
                        label="Qtde Dias Prev. Pagamento"
                        max="20"
                        min="1"
                        type="number"
                      />
                    </div>
                    <div class="col-md-3">
                      <form-helper
                        :inputVar="formFinanciamentoSolar.dataprevpagamento"
                        :form="formFinanciamentoSolar"
                        id="inputPrevPagamento"
                        label="Previsão de Pagamento"
                        icon="fa-calendar"
                        :readonly="true"
                        mask="##/##/####"
                      />
                    </div>
                    <div class="col-md-5">
                      <form-helper
                        id="dropfinanciamento"
                        :inputVar="formFinanciamentoSolar.droplinhacredito"
                        :form="formFinanciamentoSolar"
                        :options="formFinanciamentoSolar.optionsLinhaCredito"
                        type="select"
                        label="Instituição de Linha de Crédito"
                        placeholder="Linha de Crédito"
                      />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <FormHelper
                        :inputVar="formFinanciamentoSolar.file"
                        :form="formFinanciamentoSolar"
                        type="file"
                        label="Upload Autorização Faturamento"
                        id="files"
                        placeholder="Clique aqui para selecionar o arquivo"
                      ></FormHelper>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <input id="permission-4" v-model="formFinanciamentoSolar.existsAlienacaoFinanciamento" type="checkbox" value="true" />
                      <label for="permission-4" style="margin-left: 5px"> Necessária alienação ao banco. </label>
                    </div>
                  </div>
                  <div class="row" v-if="formFinanciamentoSolar.existsAlienacaoFinanciamento == true">
                    <div class="col-md-6">
                      <FormHelper
                        :inputVar="formFinanciamentoSolar.textoAlienacao"
                        :form="formFinanciamentoSolar"
                        type="text"
                        label="Texto de Alienação Rodapé NF"
                        placeholder="COM ALIENACAO AO BANCO ..."
                      ></FormHelper>
                    </div>
                  </div>
                  <div class="col-sm-12">
                    <button aria-label="Enviar" class="btn primary-button" type="submit">Salvar</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div
            v-if="this.parcelaCode === 2 || (formKombi.formaPag.value === 'prazo' && formKombi.parcelas.value === 'Financ.Cartão BNDES')"
            id="divBNDS"
            class="panel panel-default"
          >
            <div class="panel-heading">
              <strong>BNDS</strong>
              <br />
              Banco Nacional de Desenvolvimento Econômico e Social
            </div>
            <div class="panel-body form row">
              <div class="col-md-12">
                <form class="form -horizontal" @submit.prevent="updateInfoBNDS">
                  <div class="col-sm-4">
                    <form-helper
                      :inputVar="formBNDS.numCartaoBNDS"
                      :form="formBNDS"
                      type="input"
                      label="Nº do Cartão"
                      mask="#### #### #### ####"
                      validationType="creditCard"
                    />
                  </div>
                  <div class="col-sm-4">
                    <form-helper
                      :inputVar="formBNDS.validadeBNDS"
                      :form="formBNDS"
                      label="Validade"
                      icon="fa-calendar"
                      mask="##/##"
                      validationType="validateDateCard"
                    />
                  </div>
                  <div class="col-sm-4">
                    <form-helper
                      id="dropBandeiraBNDS"
                      :inputVar="formBNDS.bandeiraBNDS"
                      :form="formBNDS"
                      :options="getBandeiraBNDES()"
                      type="select"
                      label="Bandeira"
                      placeholder="Bandeiras"
                    />
                  </div>
                  <div class="col-sm-4">
                    <form-helper
                      :inputVar="formBNDS.bancoBNDS"
                      :form="formBNDS"
                      :options="getBancoBNDES()"
                      type="select"
                      label="Banco"
                      placeholder="Bancos"
                    />
                  </div>
                  <div class="col-sm-4">
                    <form-helper
                      :inputVar="formBNDS.parcelaBNDS"
                      :form="formBNDS"
                      :options="getParcelasBNDES()"
                      type="select"
                      label="Nº de Parcelas"
                      placeholder="Nº de Parcelas"
                    />
                    <!-- <asp:DropDownList ID="dropParcelasBNDS" runat="server" CssClass="form-control input-sm bnds" Style="width: 100%" Visible="true" /> -->
                  </div>
                  <div class="col-sm-12">
                    <button aria-label="Enviar" class="btn primary-button" type="submit">Enviar</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <financing-santander
            :visible="isParcelaSantander && showSantander && totalSantander != null && totalSantander > 0"
            :total="totalSantander"
            :codigoCliente="formKombi.codigoCliente"
            :codigoPedido="formKombi.kombiCode"
          />

          <financing-sol-agora
            :visible="isParcelaSolAgora"
            :total="totalSolAgora"
            :codigoCliente="formKombi.codigoCliente"
            :codigoPedido="formKombi.kombiCode"
          />

          <div class="row">
            <div class="col-md-12">
              <h3 class="box-title">Informações para revenda</h3>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <vue-good-table :columns="columnsTaxes" :rows="formKombi.taxesInfo" :pagination-options="{ enabled: false }" styleClass="vgt-table">
                <template slot="table-row" slot-scope="props">
                  {{ formatCurrency(props.formattedRow[props.column.field]) }}
                </template>
                <div slot="emptystate">Sem dados para exibição</div>
              </vue-good-table>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <span class="cart-table-foot pull-left">{{ totalItems }} item(s)</span>
            </div>
            <div class="col-md-6">
              <span class="cart-table-foot pull-right">Total do Carrinho: {{ formKombi.totalCarrinho }}</span>
            </div>
          </div>

          <div v-if="!isConsumoProprio">
            <div class="row">
              <div class="col-md-12">
                <h3 class="box-title vermelho">Informações para cliente final</h3>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <button
                  aria-label="Meu Prêmio"
                  class="btn btn-success pull-right"
                  style="margin-bottom: 15px"
                  type="button"
                  data-toggle="modal"
                  data-target="#prize-modal"
                  v-bind:disabled="isCalculating"
                  @click="$refs.prizeModal.getPremio()"
                >
                  <i class="fa fa-bar-chart fa-lg" /> MEU PRÊMIO
                </button>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <vue-good-table
                  :columns="columnsTaxesCliente"
                  :rows="formKombi.taxesInfoCliente"
                  :pagination-options="{ enabled: false }"
                  styleClass="vgt-table"
                >
                  <template slot="table-row" slot-scope="props">
                    {{ formatCurrency(props.formattedRow[props.column.field]) }}
                  </template>
                  <div slot="emptystate">Sem dados para exibição</div>
                </vue-good-table>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <span class="cart-table-foot pull-left">{{ totalItems }} item(s)</span>
              </div>

              <span class="cart-table-foot pull-right"> Total do Carrinho: {{ formKombi.totalCarrinhoVD }} </span>
            </div>
          </div>
        </div>
        <div class="row" style="height: 64px">
          <div class="col-md-6">
            <button aria-label="Excluir" class="btn btn-danger" v-on:click.prevent="deleteAction()">
              Excluir <span v-if="formKombi.tipo == 'carrinho'">Carrinho</span><span v-else-if="formKombi.tipo == 'cotacao'">Cotação</span>
            </button>
          </div>
          <div class="col-md-3">
            <Loader v-if="isCalculating" />
          </div>
          <div class="col-md-3">
            <button
              v-if="formKombi.tipo == 'carrinho'"
              aria-label="Finalizar"
              class="btn btn-primary pull-right"
              v-on:click.prevent="continueAction()"
              v-bind:disabled="isCalculating"
            >
              Finalizar
            </button>
            <button
              v-else-if="formKombi.tipo == 'cotacao'"
              aria-label="Continuar"
              class="btn btn-warning pull-right"
              v-on:click.prevent="continueAction()"
              v-bind:disabled="isCalculating"
            >
              Finalizar
            </button>
          </div>
        </div>
      </div>
    </div>
    <PrizeModal :codigoPedido="formKombi.codigoKombiInt" ref="prizeModal" />
  </main>
</template>

<script>
import axios from 'axios'
import 'vue-good-table/dist/vue-good-table.css'
import FormHelper from './partials/FormHelper.vue'
import ProductTaxesTooltip from './partials/ProductTaxesTooltip'
import { VueGoodTable } from 'vue-good-table'
import FinancingSantander from './partials/my-kombi/santander/FinancingSantander'
import FinancingSolAgora from './partials/my-kombi/sol-agora/FinancingSolAgora'
import PrizeModal from './partials/PrizeModal'
import { convertNumberToReal } from '../Utils/formatNumber'
import SelectShippingNew from './SelectShippingNew'
import CarrinhoService from '@/services/CarrinhoService'
import $ from 'jquery'
import swal from 'sweetalert'

export default {
  name: 'MyKombiDirectSale',
  components: {
    VueGoodTable,
    FormHelper,
    ProductTaxesTooltip,
    FinancingSantander,
    FinancingSolAgora,
    PrizeModal,
    SelectShippingNew,
  },
  mounted() {
    const self = this
    $('#in-stock-list').hide()
    $('#out-stock-list').hide()

    let $mpag = $('#pay-method')
    let $parcels = $('#parcels')
    let $cartaocredito = $('#cartaocredito')

    $mpag.hide()
    $parcels.hide()
    $cartaocredito.hide()
    const session = JSON.parse(localStorage.getItem('usuarioLogado'))

    if (!session) {
      location.href = `${self.$SiteUrl}/login?redirectTo=${location.href}`
    }

    if (session.CodigoPedido != -1) {
      this.formKombi.codigoKombiInt = session.CodigoPedido
    } else if (session.CodigoOrcamento != -1) {
      this.formKombi.codigoKombiInt = session.CodigoOrcamento
    }

    const formaPagamento = localStorage.getItem('formaPagamento') || 'prazo'

    this.formaPagOnChange({ target: { value: formaPagamento } })

    if (session.CodigoOrcamento == -1 && this.$route.params.tipo === 'cotacao') {
      location.href = `${self.$SiteUrl}/loja/meu-carrinho/carrinho`
    }

    this.getTipoPedido()

    if (this.formKombi.parcelas.value == 'Financ. Santander') this.permissaoSantander()
    this.ValidaZeroICMS()
  },
  data() {
    return {
      loadMounted: true,
      updateParcela: true,
      totalSantander: null,
      totalSolAgora: null,
      showSantander: false,
      showFinanciamentoSolar: false,
      showModalPrize: false,
      premio: {},
      isQuotation: false,
      isVendaDireta: false,
      isPossivelConfirmacaoAut: false,
      isConsumoProprio: false,
      session: {},
      faturamentos: [],
      isCalculating: false,
      formAddProdutos: {
        codigo: new this.$formInput(false),
        quantidade: new this.$formInput(false),
      },
      formFinanciamentoSolar: {
        existsAlienacaoFinanciamento: true,
        diasPagamento: new this.$formInput(true),
        dataprevpagamento: new this.$formInput(true),
        textoAlienacao: new this.$formInput(false),
        droplinhacredito: new this.$formInput(true),
        optionsLinhaCredito: [],
        file: new this.formInput(false),
        attemptSubmit: false,
      },
      formBNDS: {
        bancoBNDS: new this.$formInput(true),
        bandeiraBNDS: new this.$formInput(true),
        validadeBNDS: new this.$formInput(true),
        numCartaoBNDS: new this.$formInput(true),
        parcelaBNDS: new this.$formInput(true),
        attemptSubmit: false,
      },
      formKombi: {
        changeParcela: false,
        updateProdutos: false,
        vendaNaoRealizaAcompanhamento: null,
        updateTotal: true,
        permission: true,
        codigoCliente: '',
        codigoKombiInt: 0,
        loading: true,
        inStockText: '',
        outStockText: '',
        attemptSubmit: false,
        kombiCode: '',
        tipo: this.$route.params.tipo,
        clienteInfo: [],
        taxesInfo: [],
        taxesInfoCliente: [],
        dateToArrive: '05/07/2019',
        vendedor: new this.$formInput(true),
        formaPag: new this.$formInput(true),
        meioPag: new this.$formInput(false),
        parcelas: new this.$formInput(false),
        cartaocredito: new this.$formInput(false),
        bandeiraCartao: new this.$formInput(false, localStorage.bandeiraCartao || '1'),
        inStockList: [],
        outStockList: [],
        vendedores: [],
        optionsParcelas: [],
        optionsCartaoCredito: [],
        codigoParcela: 0,
        codigoVendedor: 0,
        totalCarrinho: '',
        totalCarrinhoVDCartaoCredito: '',
        totalAmountClienteCreditCard: 0,
        installmentNumber: 0,
        baseCalculoFrete: 0,
        quantidadeParcelasCartao: 0,
        pagCartaoCredito: false,
      },
      columnsCli: [
        { label: 'Código', field: 'codigo' },
        { label: 'CPF/CNPJ', field: 'cpfCnpj' },
        { label: 'Razão Social', field: 'razaoSoci' },
        { label: 'UF', field: 'uf' },
      ],
      columnsTaxes: [
        { label: 'IPI', field: 'ipi', tdClass: 'align-center-td', thClass: 'align-center-td' },
        { label: 'Out. Desp.', field: 'outDesp', tdClass: 'align-center-td', thClass: 'align-center-td' },
        { label: 'Base Calc. Icms', field: 'bcIcms', tdClass: 'align-center-td', thClass: 'align-center-td' },
        { label: 'Icms', field: 'icms', tdClass: 'align-center-td', thClass: 'align-center-td' },
        { label: 'Base Calc. Icms Retido', field: 'bcrIcms', tdClass: 'align-center-td', thClass: 'align-center-td' },
        { label: 'Icms Subst. Trib.', field: 'icmsSubT', tdClass: 'align-center-td', thClass: 'align-center-td' },
        { label: 'Total produtos', field: 'totalPord', tdClass: 'align-center-td', thClass: 'align-center-td' },
      ],
      columnsTaxesCliente: [
        {
          label: 'IPI',
          field: 'ipi',
          tdClass: 'align-center-td',
          thClass: 'align-center-td',
        },
        {
          label: 'Out. Desp.',
          field: 'outDesp',
          tdClass: 'align-center-td',
          thClass: 'align-center-td',
        },
        {
          label: 'Base Calc. Icms',
          field: 'bcIcms',
          tdClass: 'align-center-td',
          thClass: 'align-center-td',
        },
        {
          label: 'Icms',
          field: 'icms',
          tdClass: 'align-center-td',
          thClass: 'align-center-td',
        },
        {
          label: 'Base Calc. Icms Retido',
          field: 'bcrIcms',
          tdClass: 'align-center-td',
          thClass: 'align-center-td',
        },
        {
          label: 'Dif. de Alíquota',
          field: 'icmsSubT',
          tdClass: 'align-center-td',
          thClass: 'align-center-td',
        },
        {
          label: 'Total produtos',
          field: 'totalPord',
          tdClass: 'align-center-td',
          thClass: 'align-center-td',
        },
      ],
      moneyConfig: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        precision: 2,
        masked: false,
      },
      productTaxesValue: [
        {
          code: '1234-5',
          value: 2000.0,
          valueCli: 2500.0,
          ipi: 8.0,
          ipiCli: 11.0,
          pis: 8.0,
          pisCli: 11.0,
          cofins: 8.0,
          cofinsCli: 11.0,
          icms: 8.0,
          icmsCli: 11.0,
          difIcms: 0.0,
        },
        {
          code: '4321-5',
          value: 3000.0,
          valueCli: 3500.0,
          ipi: 8.0,
          ipiCli: 11.0,
          pis: 8.0,
          pisCli: 11.0,
          cofins: 8.0,
          cofinsCli: 11.0,
          icms: 8.0,
          icmsCli: 11.0,
          difIcms: 0.0,
        },
      ],
      liberaPagamentoCartaoCredito: false,
      firstLoad: true,
      formulario: {},
      loadingCardValues: false,
      isUpdatingQty: false,
      reloadProductsList: false,
      reativacao: false,
    }
  },
  watch: {
    'formKombi.vendaNaoRealizaAcompanhamento': function (v) {
      var self = this
      const api = axios.create({
        withCredentials: true,
      })
      api
        .post(this.$apiUrl + 'Carrinho.svc/alterouConfirmacaoAutomatica', {
          codigoPedido: self.formKombi.codigoKombiInt,
          valor: v,
        })
        .then((response) => {})
    },
    'formKombi.inStockList.length': function (v) {
      //Oculta a lista quando não houve produtos em estoque
      let $inStock = jQuery('#in-stock-list')

      if (v > 0) {
        $inStock.show()
      } else {
        $inStock.hide()
      }
    },
    'formKombi.outStockList.length': function (v) {
      //Oculta a lista quando não houve produtos em com previsão de chegada
      let $outStock = $('#out-stock-list')

      if (v > 0) {
        $outStock.show()
      } else {
        $outStock.hide()
      }
    },
    'formFinanciamentoSolar.file.value': function (val) {
      if (val.length > 0) {
        this.enableUpload()
      } else {
        this.disableUpload()
      }
    },
    'formFinanciamentoSolar.diasPagamento.value': function (val) {
      if (parseInt(val) >= 1 && parseInt(val) <= 20) {
        let data = new Date().setHours(0, 0, 0, 0)
        data = new Date(data)

        this.faturamentos.forEach((element, index) => {
          let correctFormat = element.DataString.replace(/(\d+)\/(\d+)\/(\d+)/, '$3/$2/$1')
          let DateFaturamento = new Date(correctFormat)
          if (data <= DateFaturamento) {
            data = DateFaturamento
          }
        })
        data.setDate(data.getDate() + parseInt(val))
        this.formFinanciamentoSolar.dataprevpagamento.value = data.toLocaleDateString('pt-BR')
        this.formFinanciamentoSolar.diasPagamento.validation.status = true
      } else if (parseInt(val) <= 0) {
        this.formFinanciamentoSolar.diasPagamento.value = 1
      } else {
        this.formFinanciamentoSolar.diasPagamento.value = 20
      }
    },
    'formKombi.parcelas.value': async function (v) {
      // FORAM REMOVIDAS AS OPÇÕES DO FINANCIAMENTO VOTORANTIM (CODE 9)
      if (this.formKombi.formaPag.value == 'prazo') {
        const self = this

        if (v !== null && v.label === 'Financ. Santander') {
          self.permissaoSantander()
        }
        if (v !== null && v.label === 'Financ. Solar NF Antecipada') {
          self.showFinanciamentoSolar = true
        }
        if (this.formKombi.changeParcela || !v) return
        if (v.code == 11 && this.formKombi.codigoParcela == 19) return

        self.updateParcela = true
        self.formKombi.updateProdutos = false

        self.formKombi.inStockList.forEach((element, index) => {
          $('#cliente-in-' + index).removeAttr('readonly')
        })

        self.formKombi.outStockList.forEach((element, index) => {
          $('#cliente-out-' + index).removeAttr('readonly')
        })

        if (v.code === 11 && !self.showSantander) self.permissaoSantander()

        const dataAlterarTipoPagamento = {
          codigoPedido: this.formKombi.codigoKombiInt,
          cdCliente: this.formKombi.codigoCliente,
          nrFilial: 1,
          tipoVenda: 1,
          formaPagamento: v.code,
          nmFormaPagamento: this.parcelaLabel,
        }

        const response = await CarrinhoService.AlterarTipoPagamento(this.$apiUrl, dataAlterarTipoPagamento)

        if (response) {
          if (v.code == 11 && this.formKombi.codigoParcela != 19) {
            self.updateParcela = false
            self.reloadTotalCarrinho()
          }
        }
      }
    },
  },
  computed: {
    totalItems: function () {
      //Calcula a quatidade dos itens no carrinho
      return this.formKombi.outStockList.length + this.formKombi.inStockList.length
    },
    formErrosBNDS: function () {
      // Retorna os campos que estão com erro de validação
      const errors = Object.keys(this.formBNDS).filter((key) => this.formBNDS[key].validation && !this.formBNDS[key].validation.status)

      return errors.length
    },
    formErrosFinanciamentoSolar: function () {
      // Retorna os campos que estão com erro de validação
      const errors = Object.keys(this.formFinanciamentoSolar).filter(
        (key) => this.formFinanciamentoSolar[key].validation && !this.formFinanciamentoSolar[key].validation.status
      )

      return errors.length
    },
    formErrors: function () {
      // Retorna os campos que estão com erro de validação
      const errors = Object.keys(this.formKombi).filter(
        (key) =>
          this.formKombi[key].required != null &&
          this.formKombi[key].required &&
          this.formKombi[key].validation != null &&
          this.formKombi[key].validation &&
          this.formKombi[key].validation.status != null &&
          !this.formKombi[key].validation.status
      )

      return errors.length
    },

    isParcelaSantander: function () {
      return this.parcelaCode == 11 && this.parcelaLabel.toLowerCase().includes('santander')
    },

    isParcelaSolAgora: function () {
      return this.parcelaCode == 11 && this.parcelaLabel.toLowerCase().includes('sol agora')
    },

    parcelaCode: function () {
      if (this.formKombi.parcelas.value == undefined) return ''
      if (this.formKombi.parcelas.value.code == undefined) return ''
      return this.formKombi.parcelas.value.code
    },

    parcelaLabel: function () {
      if (this.formKombi.parcelas.value == undefined) return ''
      if (this.formKombi.parcelas.value.label == undefined) return ''
      return this.formKombi.parcelas.value.label
    },
  },
  methods: {
    formaPagOnChange: async function (valuepag) {
      const v = valuepag.target.value
      let $mpag = $('#pay-method')
      let $parcels = $('#parcels')
      let $cartaocredito = $('#cartaocredito')

      const dadosCliente = JSON.parse(localStorage.getItem('usuarioLogado')).DadosCliente
      this.isCalculating = true
      this.formKombi.updateProdutos = false

      this.formKombi.parcelas = new this.$formInput(false)
      this.formKombi.parcelas.required = v == 'prazo'
      this.formKombi.meioPag.required = v == 'vista'
      this.formKombi.changeParcela = v == 'vista'
      this.formKombi.cartaocredito = new this.$formInput(false)
      this.formKombi.cartaocredito.required = v == 'cartaocredito'
      this.formKombi.codigoParcela = v == 'vista' ? 0 : this.formKombi.codigoParcela
      this.formKombi.totalCarrinhoCartaoCredito = ''
      this.formKombi.pagCartaoCredito = false
      this.formKombi.totalCarrinho = '------'
      this.formKombi.totalCarrinhoVD = '------'

      const formaPagamentoAnterior = localStorage.formaPagamento
      localStorage.formaPagamento = v

      if (v == 'vista') {
        this.formKombi.vendaNaoRealizaAcompanhamento = 1

        if (!this.formKombi.meioPag.value) this.formKombi.meioPag.value = this.getMeiosPag()[0]
        localStorage.meioPagamento = this.formKombi.meioPag.value != null ? this.formKombi.meioPag.value.label : 'Boleto / PIX'
        this.verificaConfirmacaoAutomatica()

        this.formKombi.changeParcela = true
        this.formKombi.pagCartaoCredito = false

        localStorage.removeItem('parcelaSelecionada')

        $mpag.show()
        $parcels.hide()
        $cartaocredito.hide()

        const dataAlterarTipoPagamento = {
          codigoPedido: this.formKombi.codigoKombiInt,
          cdCliente: this.formKombi.codigoCliente,
          nrFilial: 1,
          tipoVenda: 0,
          formaPagamento: 3,
          nmFormaPagamento: this.parcelaLabel,
        }

        const response = await CarrinhoService.AlterarTipoPagamento(this.$apiUrl, dataAlterarTipoPagamento)

        if (response === '{"T":"","Message":""}') {
          this.reloadTotalCarrinho()
        } else {
          this.formKombi.formaPag.value = formaPagamentoAnterior
          if (response) {
            swal({
              title: 'Aviso',
              text: response,
              icon: 'warning',
            })
          }
        }
      } else if (v == 'prazo') {
        this.formKombi.vendaNaoRealizaAcompanhamento = 0
        $mpag.hide()
        $cartaocredito.hide()
        $parcels.show()

        localStorage.removeItem('meioPagamento')
        this.formKombi.meioPag = new this.$formInput(false)
        this.formKombi.pagCartaoCredito = false

        if (dadosCliente.CliTipocadastro !== 0) {
          const dataAlterarTipoPagamento = {
            codigoPedido: this.formKombi.codigoKombiInt,
            cdCliente: this.formKombi.codigoCliente,
            nrFilial: 1,
            tipoVenda: 1,
            formaPagamento: 0,
          }

          const response = await CarrinhoService.AlterarTipoPagamento(this.$apiUrl, dataAlterarTipoPagamento)

          if (response === '{"T":"","Message":""}') {
            if (this.formKombi.optionsParcelas.length === 0) {
              await this.getParcelas()
              this.getLinhaCredito()
            }
            this.reloadTotalCarrinho()
          } else {
            this.formKombi.formaPag.value = formaPagamentoAnterior
            if (response) {
              swal({
                title: 'Aviso',
                text: response,
                icon: 'warning',
              })
            }
          }
        } else {
          this.formKombi.formaPag.value = 'vista'
          this.formKombi.permission = false
          swal({
            title: 'Aviso',
            text: 'Você não tem permissão para selecionar esta forma de pagamento!',
            icon: 'warning',
          })
        }
      } else if (v == 'cartaocredito') {
        $('#formas-pagamento .inline-radio>input[type=radio]').attr('checked', false)
        $mpag.hide()
        $parcels.hide()
        $cartaocredito.attr('checked', true)
        $cartaocredito.show()

        this.alterarBandeiraCartao()

        this.formKombi.bandeiraCartao.required = true
        this.formKombi.vendaNaoRealizaAcompanhamento = 0
        this.formKombi.pagCartaoCredito = true
        this.formKombi.meioPag.value = null
        localStorage.removeItem('meioPagamento')
      } else {
        this.formKombi.formaPag.value = formaPagamentoAnterior
        this.formKombi.permission = false
        swal({
          title: 'Aviso',
          text: 'Você não tem permissão para selecionar esta forma de pagamento!',
          icon: 'warning',
        })
      }

      this.dadosProdutos()
    },
    replaceAll: function (string, token, newtoken) {
      while (string.indexOf(token) != -1) string = string.replace(token, newtoken)
      return string
    },
    uploadingStatus: function () {
      //Desabilita o botão de upload e o input para que não remova ou selecione outro arquivo durante o upload
      this.isUploading = true
      $('#files').css('pointer-events', 'none')
    },
    searchingStatus: function () {
      let $btnIcon = $('#btn-icon')
      $btnIcon.removeClass('fa-search')
      $btnIcon.addClass('fa-spinner fa-spin')
      $('#btn-search').prop('disabled', true)
    },
    disableUpload: function () {
      //Desabilita o botão de upload de arquivo quando não há arquivo selecionado
      this.isUploading = false
      $('#btn-upnf').prop('disabled', true)
      $('#files').css('pointer-events', 'auto')
    },
    enableUpload: function () {
      //Habilita o botão de upload de arquivo quando há arquivo selecionado
      this.isUploading = false
      $('#btn-upnf').prop('disabled', false)
      $('#files').css('pointer-events', 'auto')
    },
    formInput: function (required, value) {
      // Define um padrão para estrutura de cada input do formulário
      this.required = required !== undefined ? required : true
      this.value = value !== undefined ? value : ''

      this.validation = {
        // Status é o inverso do requerido, pois se o input for obrigatório, ele inicia com o status inválido
        // Para que o usuário seja barrado em caso de um submit sem dados
        status: !this.required,
        message: this.required ? 'Por favor, preencha o campo acima' : '',
      }
    },
    updateFinanciamentoSolar: function () {
      this.formFinanciamentoSolar.attemptSubmit = true
      if (this.formErrosFinanciamentoSolar === 0) {
        let xhr = new XMLHttpRequest()
        let arquivo = this.formFinanciamentoSolar.file.value
        xhr.open('POST', this.$apiUrl + 'Carrinho.svc/AlterarInfoFinanciamentoSolar')
        xhr.setRequestHeader('Content-type', 'application/json')
        xhr.withCredentials = true

        xhr.onload = () => {
          if (xhr.status == 200) {
            let response = JSON.parse(xhr.responseText)

            if (!response.includes('OK')) {
              swal({
                title: response.replace(/´/g, ''),
                icon: 'warning',
              })
            } else {
              if (arquivo == '') {
                swal({
                  title: 'Informações do Financiamento alteradas com sucesso! \r\n Caso possuir autorizacao de faturamento favor realizar o anexo!',
                  icon: 'success',
                })
              } else {
                this.uploadingStatus()
                xhr = new XMLHttpRequest()
                if (this.formFinanciamentoSolar.file.size > 2097 * 1000) {
                  swal({
                    title: 'Tamanho máximo de arquivo: 2MB',
                    icon: 'error',
                  })
                  this.formFinanciamentoSolar.file.value = ''
                } else {
                  xhr.onload = () => {
                    if (xhr.status == 201) {
                      //Chamar esse swal caso o retorno seja sucesso (2xx)
                      swal({
                        title: 'Informações do Financiamento alteradas com sucesso! Upload Realizado com Sucesso!',
                        icon: 'success',
                      })
                      //Chamar esse método depois do sucesso do envio para limpar o arquivo e liberar o input para novos uploads
                      this.formFinanciamentoSolar.file.value = ''
                    } else if (xhr.status == 403) {
                      swal({
                        title: 'Usuário sem permissão!',
                        icon: 'success',
                      })
                      //Chamar esse método depois do sucesso do envio para limpar o arquivo e liberar o input para novos uploads
                      this.formFinanciamentoSolar.file.value = ''
                    } else if (xhr.status == 406) {
                      swal({
                        title: 'Verifique a extensão do arquivo',
                        text: 'só serão aceitos: .jpg, .gif, .png, .pdf ou .xml',
                        icon: 'warning',
                      })
                      //Chamar esse método depois do sucesso do envio para limpar o arquivo e liberar o input para novos uploads
                      this.formFinanciamentoSolar.file.value = ''
                    } else {
                      //Chamar esse swal caso o retorno seja falha (4xx, 5xx e etc...)
                      swal({
                        title: 'Erro ao enviar arquivo!',
                        icon: 'error',
                      })
                      this.formFinanciamentoSolar.file.value = ''
                    }
                  }
                  xhr.open('POST', this.$apiUrl + 'Carrinho.svc/uploadAutorizacaoFaturamento')
                  xhr.setRequestHeader('Content-Type', 'application/json')
                  xhr.withCredentials = true
                  this.searchingStatus()
                  xhr.send(
                    JSON.stringify({
                      nomeArquivo: this.formFinanciamentoSolar.file.name,
                      tipoDocumento: this.formFinanciamentoSolar.file.tipo,
                      bytesArquivo: arquivo,
                      codPedidoVenda: this.formKombi.codigoKombiInt,
                    })
                  )
                }
              }
            }
          }
        }

        let linhacredito = this.formFinanciamentoSolar.droplinhacredito.value
        let optionslinhaCredito = this.formFinanciamentoSolar.optionsLinhaCredito
        let objlinhaCredito = optionslinhaCredito.filter((value) => value.code === linhacredito.code)[0].code

        xhr.send(
          JSON.stringify({
            codigoPedido: this.formKombi.codigoKombiInt,
            codigoLinhaCredito: objlinhaCredito,
            previsaoPagamento: this.formFinanciamentoSolar.dataprevpagamento.value,
            textoAlienacao: this.formFinanciamentoSolar.textoAlienacao.value,
          })
        )
      }
    },
    verificaConfirmacaoAutomatica: function () {
      let self = this
      const api = axios.create({
        withCredentials: true,
      })
      api
        .post(this.$apiUrl + 'Carrinho.svc/verificaConfirmacaoAutomatica', {
          cod_pedido: this.formKombi.codigoKombiInt,
        })
        .then((response) => {
          self.isPossivelConfirmacaoAut = response.data
          if (self.isPossivelConfirmacaoAut == false) {
            self.formKombi.vendaNaoRealizaAcompanhamento = 1
          }
        })
    },
    updateInfoBNDS: function () {
      this.formBNDS.attemptSubmit = true

      if (this.formErrosBNDS === 0) {
        let xhr = new XMLHttpRequest()

        xhr.open('POST', this.$apiUrl + 'Carrinho.svc/AlterarInfoBNDES')
        xhr.setRequestHeader('Content-type', 'application/json')
        xhr.withCredentials = true

        xhr.onload = () => {
          if (xhr.status == 200) {
            let response = JSON.parse(xhr.responseText)

            if (!response.includes('OK')) {
              swal({
                title: response.replace(/´/g, ''),
                icon: 'warning',
              })
            } else {
              swal({
                title: 'Informações do BNDES alteradas com sucesso!',
                icon: 'success',
              })
            }
          }
        }

        let numCartao = this.replaceAll(this.formBNDS.numCartaoBNDS.value, ' ', '')
        let bandeiraCartao =
          this.formBNDS.bandeiraBNDS.value.code === undefined ? this.formBNDS.bandeiraBNDS.value : this.formBNDS.bandeiraBNDS.value.code
        let banco = this.formBNDS.bancoBNDS.value.code === undefined ? this.formBNDS.bancoBNDS.value : this.formBNDS.bancoBNDS.value.code
        let parcela = this.formBNDS.parcelaBNDS.value.code === undefined ? this.formBNDS.parcelaBNDS.value : this.formBNDS.parcelaBNDS.value.code

        let bandeiras = this.getBandeiraBNDES()
        bandeiraCartao = bandeiras.filter((value) => value.label === bandeiraCartao || value.code === bandeiraCartao)[0].code

        let bancos = this.getBancoBNDES()
        banco = bancos.filter((value) => value.label === banco || value.code === banco)[0].code

        try {
          parcela = parcela.replace('x', '')
        } catch {}

        xhr.send(
          JSON.stringify({
            codigoPedido: this.formKombi.codigoKombiInt,
            numeroCartao: numCartao,
            vencimentoCartao: this.formBNDS.validadeBNDS.value,
            bandeiraCartao: bandeiraCartao,
            banco: banco,
            parcela: parcela,
          })
        )
      }
    },
    getParcelasBNDES: function () {
      let parcelas = []
      for (let index = 3; index <= 36; index++) {
        let parcela = {}
        parcela.code = index
        parcela.label = index + 'x'
        parcelas.push(parcela)
      }

      return parcelas
    },
    getBandeiraBNDES: function () {
      return [
        { code: 'VISA', label: 'VISA' },
        { code: 'MASTERCARD', label: 'MASTERCARD' },
        { code: 'ELO', label: 'ELO' },
        { code: 'CABAL', label: 'CABAL' },
      ]
    },
    getLinhaCredito: function () {
      this.formFinanciamentoSolar.optionsLinhaCredito = []
      let self = this
      const xhr = new XMLHttpRequest()
      xhr.onload = () => {
        if (xhr.status == 200) {
          if (xhr.responseText != '' && xhr.responseText != null) {
            self.formFinanciamentoSolar.optionsLinhaCredito = []
            let json = JSON.parse(xhr.responseText)
            json.forEach((element) => {
              let obj = {}
              obj.code = element.codigo
              obj.label = element.nome

              self.formFinanciamentoSolar.optionsLinhaCredito.push(obj)
            })
          }
        }
      }
      xhr.open('POST', this.$apiUrl + 'Carrinho.svc/GetLoadFinanciamentoSolar')
      xhr.setRequestHeader('Content-Type', 'application/json')
      xhr.withCredentials = true
      xhr.send(
        JSON.stringify({
          codigoPedido: this.formKombi.codigoKombiInt,
        })
      )
    },
    getBancoBNDES: function () {
      return [
        { code: 'BRADESCO', label: 'Banco Bradesco S.A' },
        { code: 'BB', label: 'Banco do Brasil S.A' },
        { code: 'SICREDI', label: 'Banco Cooperativo Sicredi S.A.' },
        { code: 'ITAU', label: 'Banco Itaucard S.A.' },
        {
          code: 'BRDE',
          label: 'Banco Regional de Desenvolvimento do Extremo Sul (BRDE)',
        },
        { code: 'SANTANDER', label: 'Banco Santander (Brasil) S.A.' },
        { code: 'BANRISUL', label: 'Banrisul S.A.' },
        { code: 'CAIXA', label: 'Caixa Econômica Federal' },
        {
          code: 'SICOOB',
          label: 'Sistema de Cooperativas de Crédito do Brasil (Sicoob)',
        },
        { code: 'BANCONORDESTE', label: 'Banco do Nordeste Do Brasil S.A.' },
        { code: 'BANESTES', label: 'Banestes' },
      ]
    },
    clearFormaPagamento() {
      localStorage.formaPagamento = ''
      localStorage.removeItem('parcelaSelecionada')
    },
    reloadTotalCarrinho() {
      this.totalSantander = null
      this.formKombi.updateTotal = false
      this.isCalculating = true
      this.formKombi.totalCarrinho = '------'
      this.formKombi.totalCarrinhoVD = '------'
      this.dadosPedido()
    },
    updateValorProduto: function (product) {
      if (this.parcelaCode === 9) return

      if (this.formKombi.parcelas.value === 'Financ. BV Financeira - S/ Comissão com Frete Incluso') return

      this.isCalculating = true

      const xhr = new XMLHttpRequest()
      xhr.onload = () => {
        if (xhr.status == 200) {
          if (xhr.responseText != '' && xhr.responseText != null) {
            let json = JSON.parse(xhr.responseText)

            if (!json[0].includes('OK')) {
              let span = document.createElement('span')
              span.innerHTML = json[1]
              swal({
                content: span,
                icon: 'warning',
              })
              product.clienteV = product.valorRev
            } else {
              swal({
                title: 'Valor do produto alterado com sucesso!',
                text: `Código do produto: ${product.code}`,
                icon: 'success',
              })
              product.valorRev = product.clienteV


              this.updateParcela = false
              this.reloadTotalCarrinho()
            }
          }
        }
        this.isCalculating = false
      }
      xhr.open('POST', this.$apiUrl + 'Carrinho.svc/AlterarValorDeProduto')
      xhr.setRequestHeader('Content-Type', 'application/json')
      xhr.withCredentials = true
      xhr.send(
        JSON.stringify({
          codigoPedido: this.formKombi.codigoKombiInt,
          prd_codigo: product.code,
          valor: product.clienteV.replace('R$ ', ''),
          cdCliente: this.formKombi.codigoCliente,
          nrFilial: 1,
        })
      )
    },
    getTipoPedido: function () {
      const response = localStorage.getItem('GetTipoPedido')

      if (response.includes('DIRETA')) {
        this.isVendaDireta = true
      } else if (response.includes('IMOBILIZADO')) {
        this.isConsumoProprio = true
      } else {
        this.isVendaDireta = false
        this.isConsumoProprio = false
      }

      if (this.isVendaDireta) {
        this.reloadProductsList = localStorage.formaPagamento !== 'cartaocredito'
        this.dadosPedido()
        return
      } else {
        location.href = `${this.$SiteUrl}/loja/meu-carrinho-venda-direta/` + this.$route.params.tipo
      }

      if (!this.isVendaDireta) {
        if (!this.isConsumoProprio) {
          location.href = `${this.$SiteUrl}/loja/meu-carrinho/carrinho`
        }
      }
    },
    dadosProdutos: function () {
      let localStorageProducts = []
      localStorage.products = ''

      this.isCalculating = true
      const xhr = new XMLHttpRequest()
      xhr.onload = () => {
        if (xhr.status == 200) {
          if (xhr.responseText != '' && xhr.responseText != null) {
            let json = JSON.parse(xhr.responseText)

            this.faturamentos = json
            this.faturamentos.forEach((faturamento) => {
              this.formKombi.inStockList = []
              this.formKombi.outStockList = []

              faturamento.Produtos.forEach((produto) => {
                let item = {}
                item.code = produto.Codigo
                item.dv = produto.Dv
                item.img = produto.UrlImagem
                item.desc = produto.Descricao
                item.qtde = produto.QtdePedido.replace(',00', '')
                item.unitV = produto.ValorUnitarioRevenda
                item.clienteV = this.formatCurrency(produto.ValorUnitario)
                item.prodPai = produto.ProdutoPai
                item.valorRev = this.formatCurrency(produto.ValorUnitario)
                // item.taxes = [{icms: 0, reduct: 0, ppb: 0, ipi: 0, cfop: 0, ncm: 0, mva: 0}]
                // item.origin = ''

                let dataLayerProduct = {
                  sku: `${produto.Codigo}-${produto.Dv}`,
                  desc: produto.Descricao,
                  price: produto.ValorUnitarioRevenda,
                  quant: produto.QtdePedido,
                }

                localStorageProducts.push(dataLayerProduct)

                axios
                  .post(this.$apiUrl + 'Carrinho.svc/InformativoImpostos', {
                    codigoPedido: this.formKombi.codigoKombiInt,
                    prd_codigo: item.code,
                  })
                  .then((response) => {
                    let impostos = response.data

                    item.taxes = [
                      {
                        icms: impostos.Icms,
                        reduct: impostos.Reducao,
                        ppb: impostos.Ppb,
                        ipi: impostos.Ipi,
                        cfop: impostos.Cfop,
                        ncm: impostos.Nbm,
                        mva: impostos.Mva,
                      },
                    ]

                    item.origin = impostos.Origem

                    if (faturamento.TextoFaturamento.includes('disponibilidade')) this.formKombi.inStockList.push(item)
                    else this.formKombi.outStockList.push(item)
                  })
              })

              if (faturamento.TextoFaturamento.includes('disponibilidade')) this.formKombi.inStockText = faturamento.TextoFaturamento
              else this.formKombi.outStockText = faturamento.TextoFaturamento
            })

            localStorage.products = JSON.stringify(localStorageProducts)
            this.formKombi.loading = false

            this.carregaDataLayerCheckout(JSON.parse(localStorage.products))
          }
        }
      }
      xhr.open('POST', this.$apiUrl + 'Carrinho.svc/LoadProducts')
      xhr.setRequestHeader('Content-Type', 'application/json')
      xhr.withCredentials = true
      xhr.send(
        JSON.stringify({
          codigoPedido: this.formKombi.codigoKombiInt,
        })
      )
    },
    dadosPedido: async function () {
      const self = this
      let pedidoParametro = 0
      if (self.formKombi.codigoKombiInt === -1) {
        swal({
          title: 'Nenhum carrinho/cotação foram encontrados',
          buttons: 'Ok',
          dangerMode: true,
          icon: 'error',
        }).then(() => {
          location.href = `${self.$SiteUrl}/Loja`
        })
      } else {
        self.isCalculating = true
        if (self.session.CodigoPedido != -1) {
          pedidoParametro = self.session.CodigoPedido
          self.isQuotation = false
        } else if (self.session.CodigoOrcamento != -1) {
          pedidoParametro = self.session.CodigoOrcamento
          self.isQuotation = true
        }

        try {
          const json = await CarrinhoService.CarregarFormulario(self.$apiUrl, pedidoParametro, self.isQuotation)
          self.formulario = json

          const cliente = {
            razaoSoci: json.Razao_social_cliente,
            codigo: `${json.Codigo_cliente}-${json.Dv_cliente}`,
            cpfCnpj: json.Cnpj_cliente,
            uf: json.Uf_cliente,
            carteira: json.CarteiraCliente,
          }

          self.reativacao = json.AlteraVendedor

          const impostos = {
            ipi: json.Total_ip,
            outDesp: json.Despesas_acessorias,
            bcIcms: json.Total_base_icms,
            icms: json.Total_icms,
            bcrIcms: json.Total_base_icms_retido,
            icmsSubT: json.Total_icms_retido,
            totalPord: json.Total_produtos,
          }

          const impostosVD = {
            ipi: json.Total_ip_venda_direta,
            outDesp: json.Despesas_acessorias_venda_direta,
            bcIcms: json.Total_base_icms_venda_direta,
            icms: json.Total_icms_venda_direta,
            bcrIcms: json.Total_base_icms_retido_venda_direta,
            icmsSubT: json.Total_icms_retido_venda_direta,
            totalPord: json.Total_produtos_venda_direta,
          }

          if (self.loadMounted || self.isUpdatingQty) {
            const $mpag = $('#pay-method')
            const $parcels = $('#parcels')
            const $cartaocredito = $('#cartaocredito')
            self.formKombi.codigoParcela = json.Codigo_parcela

            if (self.formKombi.codigoVendedor == 0)
                self.getVendedores();

            self.formKombi.codigoVendedor = json.Vendedor

            if (json.prev_pagamentofinanciamento != null) {
              self.formFinanciamentoSolar.dataprevpagamento.value = json.prev_pagamentofinanciamento
            }

            const formasPag = self.payForms()

            let formaPagSelecionado = formasPag.filter((c) => {
              const vista = c.code === json.Tipo_venda && c.value === 'vista'
              const prazo = json.Tipo_venda === 1 && c.code !== 15 && c.value === 'prazo' && !self.formKombi.pagCartaoCredito
              const cartao = json.Tipo_venda === 1 && c.code === 15 && c.value === 'cartaocredito' && self.formKombi.pagCartaoCredito
              if (vista) return true
              if (prazo) return true
              return cartao
            })[0]

            self.formKombi.formaPag.value = formaPagSelecionado.value

            if (self.formKombi.formaPag.value === 'vista') {
              let meiosPag = self.getMeiosPag()
              let meioPagSelecionado = meiosPag.filter((c) => c.code == json.Forma_pagamento)
              if (meioPagSelecionado.length > 0) self.formKombi.meioPag.value = meioPagSelecionado[0]
              $mpag.show()
              $parcels.hide()
              $cartaocredito.hide()
              localStorage.setItem('formaPagamento', 'vista')
            }
            if (self.formKombi.formaPag.value === 'prazo' && self.updateParcela) {
              self.getParcelas()
              self.getLinhaCredito()
              $mpag.hide()
              $cartaocredito.hide()
              $parcels.show()
            }

            if (self.formKombi.formaPag.value === 'cartaocredito') {
              self.getParcelasCartaoCredito(json.Codigo_pedido)
              let formaPagSelecionado = formasPag.filter((c) => c.code == 15)[0]
              self.formKombi.formaPag.value = formaPagSelecionado.value
              $mpag.hide()
              $parcels.hide()
              $cartaocredito.attr('checked', true)
              $cartaocredito.show()
            }

            if (json.Tipo_prazo_venda_direta == 11) {
              let formaPagSelecionado = formasPag.filter((c) => c.code == 1)[0]
              self.formKombi.formaPag.value = formaPagSelecionado.value
            }

            if (json.Bandeira_cartao_bnds != null) {
              self.formKombi.codigoParcela = 2

              let bancoSelecionado = self.getBancoBNDES().filter((c) => c.code == json.Banco_cartao_bnds.trim())[0]
              self.formBNDS.bancoBNDS.value = bancoSelecionado
              self.formBNDS.bandeiraBNDS.value = json.Bandeira_cartao_bnds
              self.formBNDS.numCartaoBNDS.value = json.Numero_cartao_bnds

              let parcelaSelecionada = self.getParcelasBNDES().filter((c) => c.code == json.Parcela_bnds)[0]
              self.formBNDS.parcelaBNDS.value = parcelaSelecionada
              self.formBNDS.validadeBNDS.value = json.Validade_cartao_bnds
            }
          }

          self.formKombi.taxesInfo = []
          self.formKombi.taxesInfoCliente = []
          self.formKombi.clienteInfo = []

          self.formKombi.taxesInfo.push(impostosVD)
          self.formKombi.taxesInfoCliente.push(impostos)
          self.formKombi.clienteInfo.push(cliente)

          self.formKombi.totalCarrinho = self.formatCurrency(json.Total_nota_fiscal_venda_direta)
          self.formKombi.totalCarrinhoVD = self.formatCurrency(json.Total_nota_fiscal)
          self.formKombi.totalAmountClienteCreditCard = json.Valor_com_juros_cartao
          self.formKombi.installmentNumber = json.Parcela_cartao_credito
          self.formKombi.baseCalculoFrete = json.Total_produtos

          self.totalSantander = json.Total_nota_fiscal
          self.totalSolAgora = json.Total_nota_fiscal

          self.formKombi.kombiCode = json.Codigo_pedido + '-' + json.Dv_pedido
          self.formKombi.codigoCliente = self.formKombi.clienteInfo[0].codigo.split('-')[0]

          if ((!self.formKombi.updateTotal && self.formKombi.updateProdutos && self.updateParcela) || self.reloadProductsList) {
            self.dadosProdutos()
          }

          if ((self.formKombi.parcelas.value === '' || self.formKombi.parcelas.value == null) && json.prev_pagamentofinanciamento != null) {
            self.showFinanciamentoSolar = false
          } else {
            if (self.formKombi.parcelas.value == null) {
              self.showFinanciamentoSolar = false
            } else if (self.formKombi.parcelas.value.label === 'Financ. Solar NF Antecipada') {
              self.showFinanciamentoSolar = true
            } else {
              self.showFinanciamentoSolar = false
            }
          }
          if (self.isConsumoProprio) {
            self.formKombi.formaPag.value = 'prazo'
            self.showSantander = true
          }

          self.reloadProductsList = false
          self.isUpdatingQty = false
          self.loadMounted = false
          self.isCalculating = false
        } catch (error) {
          console.log(error)
        }
      }
    },
    updateAfterSelectFrete() {
      this.isCalculating = true
      this.loadMounted = true
      this.reloadProductsList = true
      this.reloadTotalCarrinho()
    },
    dadosCliente: function () {
      const xhr = new XMLHttpRequest()
      xhr.onload = () => {
        if (xhr.status != 200) {
          location.href = `${self.$SiteUrl}/login?redirectTo=` + location.href
        }
      }
      xhr.open('POST', this.$apiUrl + 'Carrinho.svc/GetDadosCliente')
      xhr.setRequestHeader('Content-Type', 'application/json')
      xhr.withCredentials = true
      xhr.send()
    },
    permissaoSantander: function () {
      this.showSantander = true
    },
    addProduto: function () {
      const xhr = new XMLHttpRequest()
      xhr.onload = () => {
        if (xhr.status == 200) {
          if (xhr.responseText != '' && xhr.responseText != null) {
            let json = JSON.parse(xhr.responseText)
            if (json == 'Carrinho Alterado') {
              this.verificaConfirmacaoAutomatica()
              this.ValidaZeroICMS()
              location.reload()
            } else {
              let span = document.createElement('span')
              span.innerHTML = json

              swal({
                title: 'Aviso',
                content: span,
                icon: 'warning',
              })
            }
          }
        }
      }
      xhr.open('POST', this.$apiUrl + 'Carrinho.svc/AdicionarProduto')
      xhr.setRequestHeader('Content-Type', 'application/json')
      xhr.withCredentials = true

      xhr.send(
        JSON.stringify({
          codigoPedido: this.formKombi.codigoKombiInt,
          prd_codigo: this.formAddProdutos.codigo.value.split('-')[0],
          produtoDv: this.formAddProdutos.codigo.value.split('-')[1],
          qtde: parseInt(this.formAddProdutos.quantidade.value),
        })
      )
    },
    removeInStock: function (prodIndex) {
      //Remover um produto da lista em estoque
      // var newList = [];
      // this.formKombi.inStockList.forEach(function(element, index){
      //     if(prodIndex != index){
      //         newList.push(element);
      //     }
      // });
      // this.formKombi.inStockList = newList;

      let produtoatual
      this.formKombi.inStockList.forEach(function (element, index) {
        if (prodIndex == index) {
          produtoatual = element
        }
      })
      swal({
        title: 'Exclusão de produto ' + produtoatual.code + '-' + produtoatual.dv,
        text: 'Confirma a exclusão?',
        buttons: ['Cancelar', 'Excluir'],
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) {
          const xhr = new XMLHttpRequest()
          xhr.onload = () => {
            if (xhr.status == 200) {
              if (xhr.responseText != '' && xhr.responseText != null) {
                let json = JSON.parse(xhr.responseText)
                this.clearFormaPagamento()
                location.reload()
              }
            }
          }
          xhr.open('POST', this.$apiUrl + 'Carrinho.svc/RemoverProduto')
          xhr.setRequestHeader('Content-Type', 'application/json')
          xhr.withCredentials = true
          xhr.send(
            JSON.stringify({
              codigoPedido: this.formKombi.codigoKombiInt,
              prd_codigo: produtoatual.code,
              cdCliente: this.formKombi.codigoCliente,
              nrFilial: 1,
            })
          )
        } else {
          return
        }
      })
    },
    removeOutStock: function (prodIndex) {
      let produtoatual
      this.formKombi.outStockList.forEach(function (element, index) {
        if (prodIndex == index) {
          produtoatual = element
        }
      })
      swal({
        title: 'Exclusão de produto ' + produtoatual.code + '-' + produtoatual.dv,
        text: 'Confirma a exclusão?',
        buttons: ['Cancelar', 'Excluir'],
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) {
          const xhr = new XMLHttpRequest()
          xhr.onload = () => {
            if (xhr.status == 200) {
              if (xhr.responseText != '' && xhr.responseText != null) {
                let json = JSON.parse(xhr.responseText)
                this.clearFormaPagamento()
                location.reload()
              }
            }
          }
          xhr.open('POST', this.$apiUrl + 'Carrinho.svc/RemoverProduto')
          xhr.setRequestHeader('Content-Type', 'application/json')
          xhr.withCredentials = true
          xhr.send(
            JSON.stringify({
              codigoPedido: this.formKombi.codigoKombiInt,
              prd_codigo: produtoatual.code,
              cdCliente: this.formKombi.codigoCliente,
              nrFilial: 1,
            })
          )
        } else {
          return
        }
      })
    },
    finishAction: function () {
      if (this.formKombi.totalAmountClienteCreditCard > 0) {
        let content = document.createElement('div')

        let logoBandeira = ''

        if (this.formKombi.bandeiraCartao.value == '1') logoBandeira = '/assets/images/logo-bandeiras/Visa.png'
        else if (this.formKombi.bandeiraCartao.value == '2') logoBandeira = '/assets/images/logo-bandeiras/Master.png'
        else if (this.formKombi.bandeiraCartao.value == '3') logoBandeira = '/assets/images/logo-bandeiras/Elo.png'
        else if (this.formKombi.bandeiraCartao.value == '4') logoBandeira = '/assets/images/logo-bandeiras/Hipercard.png'
        else if (this.formKombi.bandeiraCartao.value == '5') logoBandeira = '/assets/images/logo-bandeiras/Amex.png'

        content.innerHTML =
          'Valor final após transportadora escolhida: <strong>' +
          this.formatCurrency(this.formKombi.totalAmountClienteCreditCard) +
          '</strong><br>Parcelas: <strong>' +
          this.formKombi.quantidadeParcelasCartao +
          'x de ' +
          this.formatCurrency(this.formKombi.totalAmountClienteCreditCard / this.formKombi.quantidadeParcelasCartao) +
          '</strong>' +
          '</strong><br>Bandeira: <img style = ' +
          'height:35px ' +
          +'' +
          ' src = ' +
          logoBandeira +
          ' >'

        swal({
          icon: 'info',
          title: 'Forma de pagamento escolhida: Cartão de Crédito.',
          content: content,
          buttons: {
            cancel: 'Cancelar',
            alterar: { text: 'Alterar parcelamento' },
            finalizar: { text: 'Finalizar', className: 'bg-primary' },
          },
        }).then((value) => {
          switch (value) {
            case 'finalizar':
              this.finalizar(true)
              break
            default:
              break
          }
        })
      } else {
        swal({
          title: 'Finalizar Pedido',
          text: 'Deseja finalizar o pedido?',
          buttons: ['Cancelar', 'Finalizar'],
        }).then((confirmou) => {
          this.finalizar(confirmou)
        })
      }
    },
    finalizar: function (confirmou) {
      if (confirmou) {
        const dadosCliente = JSON.parse(localStorage.getItem('usuarioLogado')).DadosCliente
        this.isProcessing = true
        const xhr = new XMLHttpRequest()
        xhr.onload = () => {
          if (xhr.status == 200) {
            if (xhr.responseText != '' && xhr.responseText != null) {
              let json = JSON.parse(xhr.responseText)
              if (json.includes('OK')) {
                localStorage.vendedor = 'INTERNET'
                localStorage.formaPagamento = 'vista'
                localStorage.meioPagamento = 'Boleto'
                localStorage.bandeiraCartao = ''
                localStorage.numCartaoBNDS = ''
                localStorage.validadeBNDS = ''
                localStorage.bandeiraBNDS = ''
                localStorage.bancoBNDS = ''
                localStorage.parcelaBNDS = ''
                localStorage.parcelaSelecionada = 'Parcelas'
                localStorage.cifKombiDirect = ''
                localStorage.fobKombiDirect = ''
                localStorage.tipoFrete = ''

                // swal({
                //     title: "Pedido finalizado com sucesso!",
                //     icon: "success",
                //     button:"Ok"
                // }).then(() => {
                //     location.href = `${self.$SiteUrl}/Loja`
                // })

                // Google tag Manager - gtm.js
                const buy = {
                  event: 'purchase',
                  pageType: 'transactionSuccess',
                  transaction_id: this.formKombi.codigoKombiInt,
                  value: this.formKombi.totalCarrinho,
                  items: JSON.parse(localStorage.products),
                }

                this.$gtm.push(buy)
                localStorage.buyDataLayer = JSON.stringify(buy)

                const jsonUser = window.localStorage.getItem('usuarioLogado')
                const dadosPedido = JSON.parse(jsonUser)

                this.carregaDataLayerPurchase(JSON.parse(localStorage.products), dadosPedido)

                localStorage.removeItem('products')

                this.removeAgendamentoLocal(this.formKombi.codigoKombiInt)

                if (this.formKombi.totalCarrinhoVD > 0) {
                  let content = document.createElement('div')
                  content.innerHTML =
                    'Enviaremos para você um link de pagamento com as informações do pedido, após ele ser confirmado pelo seu vendedor.'

                  swal({
                    icon: 'success',
                    title: 'Pedido confirmado para Cartão de Crédito.',
                    content: content,
                    button: 'Ok',
                  }).then(() => {
                    location.href = '/carrinho-fechado'
                  })
                } else {
                  location.href = '/carrinho-fechado'
                }
              } else {
                let span = document.createElement('span')
                span.innerHTML = json.replace(/´/g, '')
                this.isProcessing = false
                swal({
                  title: 'Aviso',
                  content: span,
                  icon: 'warning',
                  button: 'Ok',
                })
                return
              }
            }
          }
        }
        xhr.open('POST', this.$apiUrl + 'Carrinho.svc/ConfirmarPedido')
        xhr.setRequestHeader('Content-Type', 'application/json')
        xhr.withCredentials = true
        xhr.send(
          JSON.stringify({
            codigoPedido: this.formKombi.codigoKombiInt,
            nomeUsuarioComprador: dadosCliente.UserNome,
          })
        )
      } else {
        this.isProcessing = false
        swal({
          title: 'Cancelada a finalização do pedido.',
          button: 'Ok',
        })
      }
    },
    continueAction: async function () {
      //Ação do botão continuar
      this.formKombi.attemptSubmit = true

      if (this.isParcelaSantander) {
        const respSantander = await this.VerificaPropostaSantander()
        if (respSantander) {
          swal({
            title: 'Aviso',
            text: 'Não foi realizada a proposta SANTANDER ou a proposta enviada foi negada.',
            icon: 'warning',
          })
          return
        }
      } else if (this.isParcelaSolAgora) {
        const res = await this.VerificaPropostaSolAgora()
        if (res) {
          swal({
            title: 'Aviso',
            text: 'Não foi realizada a proposta SOL AGORA ou a proposta enviada foi negada.',
            icon: 'warning',
          })
          return
        }
      } else if (!this.isParcelaSantander && !this.isParcelaSolAgora) {
        const respNFFinanciamentoAntecipado = await this.VerificaInformacoesNFAntecipada()
        if (respNFFinanciamentoAntecipado) {
          swal({
            title: 'Aviso',
            text: 'Preencher os dados de pagamento para o modelo Financiamento Antecipado.',
            icon: 'warning',
          })
          return
        }
      }

      if (await this.validarDataFaturamentos()) {
        await this.dividirPedidoPorData()
        return
      }

      if (
        this.formKombi.formaPag.value !== 'prazo' &&
        this.formKombi.formaPag.value !== 'vista' &&
        this.formKombi.formaPag.value !== 'cartaocredito'
      ) {
        swal({
          title: 'Aviso',
          text: 'Selecione uma forma de pagamento',
          icon: 'warning',
        })
      } else if (this.formKombi.formaPag.value === 'prazo' && this.formKombi.parcelas.value && this.parcelaLabel == 'Parcelas') {
        swal({
          title: 'Aviso',
          text: 'Selecione a parcela para pagamento a prazo',
          icon: 'warning',
        })
      } else if (this.formKombi.formaPag.value === 'cartaocredito' && this.formKombi.cartaocredito.value == '') {
        swal({
          title: 'Aviso',
          text: 'Selecione a quantidade de parcelas para cartão de crédito',
          icon: 'warning',
        })
      } else {
        if (this.formErrors === 0) {
          this.finishAction()
        } else {
          swal({
            title: 'Aviso',
            text: 'Preencha os campos obrigatórios',
            icon: 'warning',
          })
        }
      }
    },
    deleteAction: function () {
      const self = this
      //Ação do botão deletar
      swal({
        title: 'Exclusão do carrinho',
        text: 'Deseja excluir o carrinho ' + this.formKombi.kombiCode,
        buttons: ['Cancelar', 'Excluir'],
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) {
          const xhr = new XMLHttpRequest()
          xhr.onload = () => {
            if (xhr.status == 200) {
              if (xhr.responseText != '' && xhr.responseText != null) {
                let json = JSON.parse(xhr.responseText)
                this.removeAgendamentoLocal(this.formKombi.codigoKombiInt)

                localStorage.vendedor = 'INTERNET'
                localStorage.formaPagamento = 'vista'
                localStorage.meioPagamento = 'Boleto'
                localStorage.numCartaoBNDS = ''
                localStorage.validadeBNDS = ''
                localStorage.bandeiraBNDS = ''
                localStorage.bancoBNDS = ''
                localStorage.parcelaBNDS = ''
                localStorage.parcelaSelecionada = 'Parcelas'
                localStorage.cifKombiDirect = ''
                localStorage.fobKombiDirect = ''
                localStorage.tipoFrete = ''
                localStorage.bandeiraCartao = ''

                location.href = `${self.$SiteUrl}/Loja`
              }
            }
          }
          xhr.open('POST', this.$apiUrl + 'Carrinho.svc/CancelarPedido')
          xhr.setRequestHeader('Content-Type', 'application/json')
          xhr.withCredentials = true
          xhr.send(
            JSON.stringify({
              codigoPedido: this.formKombi.codigoKombiInt,
            })
          )
        } else {
          return
        }
      })
    },
    updateQt: function (product) {
      this.isCalculating = true
      const xhr = new XMLHttpRequest()
      xhr.onload = () => {
        if (xhr.status == 200) {
          let json = JSON.parse(xhr.responseText)

          if (json === '') {
            this.isUpdatingQty = true

            this.dadosPedido()
          } else {
            let span = document.createElement('span')
            span.innerHTML = json

            swal({
              title: 'Aviso',
              content: span,
              icon: 'warning',
            })
          }
        }
        this.isCalculating = false
      }
      xhr.open('POST', this.$apiUrl + 'Carrinho.svc/AlterarQtdePedido')
      xhr.setRequestHeader('Content-Type', 'application/json')
      xhr.withCredentials = true
      xhr.send(
        JSON.stringify({
          codigoPedido: this.formKombi.codigoKombiInt,
          prd_codigo: product.code,
          cdCliente: this.formKombi.codigoCliente,
          nrFilial: 1,
          qtde: product.qtde,
        })
      )
    },
    formatCurrency: function (v) {
      v = v.toString().replace(',', '.')
      //formata valores floats para moeda
      const formato = {
        minimumFractionDigits: 2,
        style: 'currency',
        currency: 'BRL',
      }
      return parseFloat(v).toLocaleString('pt-BR', formato)
    },
    payForms: function () {
      return [
        { code: 0, label: 'À vista', value: 'vista', visible: true },
        { code: 1, label: 'À prazo | Financiamentos', value: 'prazo', visible: true },
        { code: 15, label: 'Cartão de Crédito', value: 'cartaocredito', visible: this.liberaPagamentoCartaoCredito },
      ]
    },
    getFlags: function () {
      return [
        { code: 1, label: '', value: '1', visible: true, img: { src: '/assets/images/logo-bandeiras/Visa.png', height: 50, width: 50 } },
        { code: 2, label: '', value: '2', visible: true, img: { src: '/assets/images/logo-bandeiras/Master.png', height: 50, width: 50 } },
        { code: 3, label: '', value: '3', visible: true, img: { src: '/assets/images/logo-bandeiras/Elo.png', height: 50, width: 50 } },
        //     { code: 4, label: "", value: "4", visible: true, img: { src: "/assets/images/logo-bandeiras/Hipercard.png", height: 50, width: 50 } },//
        //     { code: 5, label: "", value: "5", visible: true, img: { src: "/assets/images/logo-bandeiras/Amex.png", height: 50, width: 50 } },//
      ]
    },
    getTodayDate: function () {
      //Retorna a data atual
      return new Date().toLocaleDateString('pt-BR')
    },
    getVendedores: function () {
      const self = this

      $.ajax({
        url: this.$apiUrl + 'Usuarios.svc/getvendedores',
        dataType: 'json',
        type: 'GET',
        xhrFields: { withCredentials: true },
        success: (data) => {
          data.forEach((element) => {
            let vendedor = {}
            vendedor.code = element.Key
            vendedor.label = element.Value
            self.formKombi.vendedores.push(vendedor)
          })

          if (self.formKombi.codigoVendedor != 0) {
            let vendedores = self.formKombi.vendedores.filter((c) => c.code === self.formKombi.codigoVendedor)
            if (vendedores.length > 0) self.formKombi.vendedor.value = vendedores[0]
            else self.formKombi.vendedor.value = { code: 94, label: 'INTERNET' }

            this.formKombi.vendedor.validation.status = true
          }
        },
      })
    },
    getMeiosPag: function () {
      //Meios de pagamento à vista
      // COVID-19
      return [
        { code: 3, label: 'Boleto / PIX' },
        //{code: 1, label: "Dinheiro"},
        //{code: 0, label: "Cheque"}
      ]
    },
    getParcelas: async function () {
      this.formKombi.optionsParcelas = []

      const json = await CarrinhoService.GetParcelasPgtoPrazo(this.$apiUrl, {
        codigoPedido: this.formKombi.codigoKombiInt,
        empCodigo: 1,
      })

      json.forEach((element) => {
        let obj = {}
        obj.code = element.CodigoPagamento
        obj.label = element.DescricaoParaInternet
        this.formKombi.optionsParcelas.push(obj)
      })

      if (this.formKombi.formaPag.value === 'prazo') {
        let parc = null
        if (this.formKombi.codigoParcela == 47) parc = this.formKombi.optionsParcelas.filter((p) => p.code === 9)[0]
        else if (this.formKombi.codigoParcela == 19) parc = this.formKombi.optionsParcelas.filter((p) => p.code === 11)[0]
        else parc = this.formKombi.optionsParcelas.filter((p) => p.code === this.formKombi.codigoParcela)[0]
        this.formKombi.parcelas = new this.$formInput(true, parc)
      }
    },
    getParcelasCartaoCredito: function (codigoPedidoCarrinho) {
      this.loadingCardValues = true
      this.formKombi.optionsCartaoCredito = []
      const bandeira = this.formKombi.bandeiraCartao.value
      axios
        .get(this.$apiUrl + `PagSeguro.svc/CreditCardInterestRates/${codigoPedidoCarrinho}/${bandeira}`)
        .then((response) => {
          if (response.data) {
            this.formKombi.optionsCartaoCredito = response.data.map((item) => {
              return {
                code: item.InstallmentCode,
                label:
                  item.InstallmentNumber +
                  'x de ' +
                  convertNumberToReal(item.FinalValue / item.InstallmentNumber) +
                  ' - ' +
                  convertNumberToReal(item.FinalValue),
                qtdParcelas: item.InstallmentNumber,
                finalValue: item.FinalValue,
              }
            })
          }
          this.loadingCardValues = false
          this.setParcelaCartaoCredito()
        })
        .catch(() => {
          swal({
            title: 'Erro ao carregar parcelas do Cartão de Crédito',
            icon: 'warning',
          })
        })
    },
    setParcelaCartaoCredito: function () {
      if (this.formKombi.formaPag.value === 'cartaocredito') {
        let parc = this.formKombi.optionsCartaoCredito.filter((p) => p.code === this.formKombi.codigoParcela)
        this.formKombi.cartaocredito = new this.$formInput(true, parc[0])

        if (this.firstLoad) {
          const totalCarrinho = parseFloat(this.formKombi.totalCarrinhoVD.replace('R$', '').replaceAll('.', '').replace(',', '.'))
          this.formKombi.totalAmountClienteCreditCard = isNaN(totalCarrinho) ? 0 : totalCarrinho
          this.firstLoad = false

          if (!!parc && parc[0] !== undefined) {
            this.atribuirTipoPagamentoCartaoCredito(parc[0])
          }
        }
      }
    },
    atribuirTipoPagamentoCartaoCredito: function (v, reload = true) {
      this.isCalculating = true
      this.formKombi.totalCarrinho = '------'
      this.formKombi.totalCarrinhoVD = '------'
      const parcela = v || this.formKombi.cartaocredito.value

      if (this.formKombi.formaPag.value == 'cartaocredito' && parcela !== null && !!parcela.code) {
        if (this.formKombi.totalAmountClienteCreditCard == parcela.finalValue) reload = false

        const xhr = new XMLHttpRequest()
        this.formKombi.quantidadeParcelasCartao = parcela.qtdParcelas
        xhr.open('POST', this.$apiUrl + 'Carrinho.svc/AtribuirTipoPagamentoCartaoCredito')
        xhr.setRequestHeader('Content-type', 'application/json')
        xhr.withCredentials = true

        xhr.send(
          JSON.stringify({
            codigoPedido: this.formKombi.codigoKombiInt,
            bandeira: this.formKombi.bandeiraCartao.value,
            codigoParcela: parcela.code,
          })
        )

        xhr.onload = () => {
          if (reload) {
            this.reloadProductsList = true
            this.reloadTotalCarrinho()
            this.formKombi.totalAmountClienteCreditCard = parcela.finalValue
          }
          this.isCalculating = false
        }

        this.formKombi.codigoParcela = parcela.code
      }
    },
    async validarDataFaturamentos() {
      return await axios
        .post(
          this.$apiUrl + 'Carrinho.svc/VerificaVariasDataFaturamento',
          {
            codigoPedido: this.formKombi.codigoKombiInt,
          },
          { withCredentials: true }
        )
        .then((response) => {
          return !!(response.data.length > 0 && !response.data.includes('Prêmio calculado é negativo'))
        })
    },
    async VerificaPropostaSantander() {
      return await axios
        .post(
          this.$apiUrl + 'Carrinho.svc/VerificaPropostaSantander',
          {
            codigoPedido: this.formKombi.codigoKombiInt,
          },
          { withCredentials: true }
        )
        .then((response) => {
          return !!(response.data.length > 0 && response.data != '')
        })
    },
    async VerificaPropostaSolAgora() {
      return await axios
        .post(
          this.$apiUrl + 'Carrinho.svc/VerificaPropostaSolAgora',
          {
            codigoPedido: this.formKombi.codigoKombiInt,
          },
          { withCredentials: true }
        )
        .then((response) => {
          return !!(response.data.length > 0 && response.data != '')
        })
    },
    async VerificaInformacoesNFAntecipada() {
      return await axios
        .post(
          this.$apiUrl + 'Carrinho.svc/VerificaInformacoesNFAntecipada',
          {
            codigoPedido: this.formKombi.codigoKombiInt,
          },
          { withCredentials: true }
        )
        .then((response) => {
          return !!(response.data.length > 0 && response.data != '')
        })
    },
    async dividirPedidoPorData() {
      return await axios
        .post(
          this.$apiUrl + 'Carrinho.svc/DividirPedidosPorDataFaturamento',
          {
            codigoPedido: this.formKombi.codigoKombiInt,
          },
          { withCredentials: true }
        )
        .then((response) => {
          var span = document.createElement('span')
          span.innerHTML =
            'O seu pedido foi dividido em mais de um, pois possui produtos com data de faturamento diferentes.<br>' +
            'Por gentileza selecione a kombi que deseja trabalhar.'
          swal({
            title: 'Pedido dividido por data de faturamento!',
            content: span,
          }).then((response) => {
            localStorage.removeItem('formaPagamento')
            localStorage.removeItem('meioPagamento')
            localStorage.parcelaSelecionada = 'Parcelas'
            location.href = this.$SiteUrl + '/loja'
          })
        })
    },
    ValidaZeroICMS: async function () {
      try {
        const response = await CarrinhoService.ValidaZeroICMS(this.$apiUrl)

        if (response === 200) {
          this.liberaPagamentoCartaoCredito = true
          return
        }
        this.liberaPagamentoCartaoCredito = false
      } catch (error) {
        console.log(error)
        this.liberaPagamentoCartaoCredito = false
      }
    },
    alterarMeioPagamento: async function (v) {
      if (!v) return
      localStorage.meioPagamento = v.label
      this.verificaConfirmacaoAutomatica()
    },
    alterarBandeiraCartao: function (event) {
      this.formKombi.loading = true

      let bandeira = localStorage.bandeiraCartao || 1

      if (event) {
        bandeira = event.target.value
      }

      this.bandeira = bandeira
      localStorage.bandeiraCartao = bandeira

      this.firstLoad = true
      this.getParcelasCartaoCredito(this.formKombi.codigoKombiInt)

      const xhr = new XMLHttpRequest()

      xhr.open('POST', this.$apiUrl + 'Carrinho.svc/AtribuirTipoPagamentoCartaoCredito')
      xhr.setRequestHeader('Content-type', 'application/json')
      xhr.withCredentials = true

      xhr.send(
        JSON.stringify({
          codigoPedido: this.formKombi.codigoKombiInt,
          bandeira: bandeira,
          codigoParcela: this.formKombi.codigoParcela,
          zerarTaxas: true,
        })
      )

      xhr.onload = () => {
        this.reloadTotalCarrinho()
        this.dadosProdutos()
      }

      this.formKombi.loading = false
    },
    alterarVendedor: function (v) {
      let xhr = new XMLHttpRequest()

      localStorage.vendedor = v.label

      xhr.open('POST', this.$apiUrl + 'Carrinho.svc/AlterarVendedor')
      xhr.setRequestHeader('Content-type', 'application/json')
      xhr.withCredentials = true

      xhr.send(
        JSON.stringify({
          codigoPedido: this.formKombi.codigoKombiInt,
          codigoVendedor: v.code,
        })
      )
    },
    alterarParcelaCartao: function (v) {
      this.atribuirTipoPagamentoCartaoCredito(v)
    },
    showLoading: function (val) {
      this.isCalculating = val
    },
    removeAgendamentoLocal: function (codigoPedido) {
      localStorage.removeItem('agendamentoPedido-' + codigoPedido)
    },
    carregaDataLayerCheckout(value) {
      if (dataLayer) {
        dataLayer.push({ ecommerce: null })
        dataLayer.push({
          event: 'begin_checkout',
          ecommerce: {
            items: value.map((x) => ({
              item_name: x.desc,
              item_id: x.sku,
              price: x.price,
              item_brand: x.desc,
              item_qtd: x.quant,
            })),
          },
        })
      }
    },
    carregaDataLayerPurchase(value, dadosPedido) {
      if (dataLayer) {
        dataLayer.push({ ecommerce: null })
        dataLayer.push({
          event: 'purchase',
          ecommerce: {
            transaction_id: dadosPedido.CodigoPedido,
            affiliation: dadosPedido.DadosCliente.CliRazaoSocial,
            value: dadosPedido.carrinhoTotalNotaFiscalSemFrete,
            currency: 'BRL',
            items: value.map((x, i) => ({
              item_name: x.desc,
              item_id: x.sku,
              price: x.prd_preco,
              item_brand: x.desc,
              index: i,
              quantity: x.quant,
            })),
          },
        })
      }
    },
  },
}
</script>
